<template>
  <div>
    <b-modal
      id="attractionManagerOptions"
      modal-class="modal-cover"
      v-model="isVisible"
      hide-backdrop
      hide-footer
      hide-header
      content-class="shadow-lg attraction-manager-content"
    >
      <!-- Own header rather than b-modal's -- same reason as
           DayManagerOptions.vue: Bootstrap's close button is pushed over
           with `margin-left: auto` inside a header that stays LTR whatever
           the page language, so in Hebrew it landed on the right, and the
           title sat below it in the body leaving an empty bar above. -->
      <section class="attraction-manager" :dir="isHebrew ? 'rtl' : 'ltr'">
        <header class="attraction-manager-header">
          <h3 class="attraction-manager-title">
            {{ `${t('attractionManagerTitlePrefix')} ${inerModalParameters?.attraction?.title}?` }}
          </h3>
          <button
            type="button"
            class="attraction-manager-close"
            :aria-label="t('close')"
            @click="isVisible = false"
          >
            <span class="material-icons" aria-hidden="true">close</span>
          </button>
        </header>

        <div class="attraction-manager-actions">
          <b-button
            variant="primary"
            class="action-button"
            @click="editAttractionDetails"
          >
            <i class="fas fa-edit"></i> {{ t('attractionManagerEdit') }}
          </b-button>

          <b-button
            variant="primary"
            class="action-button"
            @click="updateDate"
          >
            <i class="fas fa-calendar-alt"></i> {{ t('attractionManagerUpdateDate') }}
          </b-button>

          <b-button
            variant="danger"
            class="action-button"
            @click="removeAttraction"
          >
            <i class="fas fa-trash-alt"></i> {{ t('attractionManagerRemove') }}
          </b-button>

          <!-- <b-button
            variant="outline-info"
            class="action-button"
            @click="duplicateAttraction"
          >
            <i class="fas fa-copy"></i> שכפול
          </b-button> -->
        </div>
      </section>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { translationMixin } from '@/mixins/translationMixin';

export default {
  props: ["value"],
  mixins: [translationMixin],
  computed: {
    ...mapGetters(['allRide', 'inerModalParameters']),
    isVisible: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    ...mapActions([
      'showModal',
      'showModalWithParameters',
      'removeAttractionFromRide',
      'editAttraction'
    ]),
    
    removeAttraction() {
      // Show confirmation modal before removing
      this.showModalWithParameters({
        inerModalParameters: { attractionId: this.inerModalParameters.attraction.id },
        type: 'areYouShureRemovingAttraction'
      });
      this.isVisible = false;
    },

    updateDate() {
      // Set the attraction for date change and show the update time modal
      this.$store.commit('setAttractionForChangeingTheDate', this.inerModalParameters.attraction);
      this.showModal('updateAttractionTime');
      this.isVisible = false;
    },

    editAttractionDetails() {
      this.editAttraction(this.inerModalParameters.attraction.id);
      this.showModal('');
    },

    duplicateAttraction() {
      // Create a copy of the attraction
      console.log("234this si the code for duplicat the atraction!!!!! need to test if it posible")
      
      // const duplicatedAttraction = {
      //   ...this.inerModalParameters.attraction,
      //   id: null, // Clear ID for new attraction
      //   title: `${this.inerModalParameters.attraction.title} (עותק)`,
      // };
      
      // this.showModal('');
    }
  }
};
</script>

<style scoped>
/* px, never rem, throughout: this app sets html { font-size: 10px }, so the
   rem sizes this modal used resolved tiny -- the action buttons' 1.1rem was
   11px and the title's 1.5rem was 15px. Same fix as DayManagerOptions.vue,
   2026-10-05. */
.modal.modal-cover .modal-content,
.modal.modal-cover .modal-footer {
  border: none;
}

.attraction-manager {
  padding: 2px;
}

.attraction-manager-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  margin-bottom: 18px;
}

.attraction-manager-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.35;
  color: #15312E;
  text-align: center;
  /* Clear of the close button on EITHER side, so the centred title never
     collides with it when the language (and so the button's side) flips.
     This title carries the attraction's own name, so it often wraps --
     hence the padding rather than a fixed single-line height. */
  padding: 0 46px;
  overflow-wrap: anywhere;
}

.attraction-manager-close {
  position: absolute;
  /* inset-inline-END, not start: a close button sits at top-RIGHT in an
     LTR layout, so it mirrors to top-LEFT in Hebrew. `start` would put it
     back on the right in RTL, which is exactly where Bootstrap's always-LTR
     header was leaving it. */
  inset-inline-end: 0;
  top: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* 44px: a real touch target, this being tapped on a phone. */
  width: 44px;
  height: 44px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #5A6B68;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.attraction-manager-close:hover,
.attraction-manager-close:focus {
  background: #F0F3F2;
  color: #15312E;
}

.attraction-manager-close .material-icons {
  font-size: 26px;
}

.attraction-manager-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  width: 100%;
  /* >=44px: tapped on a phone. */
  min-height: 50px;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.action-button:hover {
  transform: translateY(-2px);
}

:deep(.attraction-manager-content) {
  border-radius: 16px;
  border: 0;
}

:deep(.attraction-manager-content .modal-body) {
  padding: 20px;
}
</style> 